export default __webpack_public_path__ + "static/media/calendar.5a10bd32.svg";